export const MODULE_NAME = 'arcade-root';
